<ng-container *ngIf="!isLoading else showLoading">
    <ng-container *ngIf="!done else showDone">
    <form [formGroup]="userForm" class="cas-form-floating push-up-2">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
            <ng-container *ngIf="contact">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Name</acabim-form-input-label>
                    <acabim-form-input-content>
                        <div class="cas-form-text">{{contact.user_name}}</div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Contact type</acabim-form-input-label>
                    <acabim-form-input-content>
                        <div class="cas-form-text">{{contact.contact_type.name}}</div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper *ngIf="contact.member_of && contact.member_of.legal_name">
                    <acabim-form-input-label>Organisation</acabim-form-input-label>
                    <acabim-form-input-content>
                        <div class="cas-form-text">{{contact.member_of.legal_name}}</div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </ng-container>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Email</acabim-form-input-label>
                <acabim-form-input-content>
                    <div class="cas-form-text">{{user?.user.email}}</div>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Role</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-dropdown
                        formControlName="role"
                        [options]="availableRoles"
                        inputId="role"
                        placeholder="Select role"
                        optionLabel="name"></p-dropdown>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button (click)="close()">Close</button>
        <button (click)="changeRole()" class="cas-button-action cas-button-right">Update</button>
    </div>
    </ng-container>

    <ng-template #showDone>
        <div class="cas-info">
            <h4>Done!</h4>
            <p>You have successfully updated the user role</p>
            <button class="cas-button-action" (click)="close()">Close</button>
        </div>
    </ng-template>

</ng-container>

<ng-template #showLoading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
